import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from '../assets/translates/en.json';
import ruTranslation from '../assets/translates/ru.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  ru: {
    translation: ruTranslation,
  },
};

function translationInit(lang) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: lang,
      fallbackLng: 'en',
      debug: false,
      ns: ['translation'],
      defaultNS: 'translation',
      keySeparator: false,
      interpolation: {
        escapeValue: false,
        formatSeparator: ',',
      },
      react: {
        wait: true,
      },
    });
}

export default translationInit;
